// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			// $('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			// $('ul.submenu',this).fadeOut(200);
		});

		
		//For accordion quad
		$('.accordion > li > .accordion__content').hide();
		$('.accordion > li:first').addClass("active").find(".accordion__content").slideDown();
		$('.accordion > li').click(function(e) {
			e.stopPropagation()
			
		  if ($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(this).find(".accordion__content").slideUp();

		  } else {
			$(".accordion > li.active .accordion__content").slideUp();
			$(".accordion > li.active").removeClass("active");
			$(this).addClass("active").find(".accordion__content").slideDown();
		  }
		  
		 	 $(this).siblings().removeClass('active');
			var href = $(this).attr('data-target');
			$(href).addClass('active');
			$(href).siblings().removeClass('active');
		});
		
		//ADA ADJUST
		$('.footer__content .secondary-navigation').removeAttr('id');
		$('.footer__content .secondary-navigation__list').removeAttr('id');
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());
// main menu
// let clickMe = document.getElementById('header__menu-js');
// 	clickMe.addEventListener('click', function (event) {
// 	let nav = document.getElementById("nav")
//     let toggle = document.getElementById("header__menu-js")
//     nav.classList.add("active")
//     toggle.classList.add("active")
// 	document.getElementById("menu-title").innerHTML = "close";
// });

// No Click link header
if (document.querySelector(".no-click") != null) {
	
	document.querySelector(".no-click").addEventListener('click' , (e) =>{
		e.preventDefault();
	})
}


document.getElementById('header__menu-js').addEventListener('click', function(){
	let nav = document.getElementById("nav");
	let toggle = document.getElementById("header__menu-js");
	let menu_title = document.getElementById('menu-title');
	if(!this.classList.contains('active')){
		this.parentElement.classList.add('active');
		this.classList.add('active');
		nav.classList.add('active');
		toggle.classList.add('active');
		menu_title.innerHTML = "Close";

	} else {
		this.classList.remove('active');
		this.parentElement.classList.remove('active');
		nav.classList.remove('active');
		toggle.classList.remove('active');
		menu_title.innerHTML = "menu";
	}
});

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.querySelector('.terms-and-conditions')){
			document.getElementById('header').classList.add('down')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	
	// if(document.getElementById('header').classList.contains('down')){
	// 	//Number count animation
	// 	function animateValue(obj, start, end, duration) {
	// 		let startTimestamp = null;
	// 		const step = (timestamp) => {
	// 			if (!startTimestamp) startTimestamp = timestamp;
	// 			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
	// 			obj.innerHTML = Math.floor(progress * (end - start) + start);
	// 			if (progress < 1) {
	// 				window.requestAnimationFrame(step);
	// 			}
	// 		};
	// 		window.requestAnimationFrame(step);
	// 	}

	// 	const obj = document.querySelectorAll(".bg-seccion__content .number ");
	// 	obj.forEach((item) => {		
	// 		animateValue(item, 0, item.innerHTML, 3000)
	// 		//console.log(item.innerHTML);
	// 	})
	// 	//animateValue(obj, 0, 6, 500);	
	// }
	
}
